import BaseApi from "@/core/HttpResources/BaseApi";
import SendedPorposal from "@/models/porposal/sendedPorposal.Model";
import Porposal from '../models/porposal/porposal.model';
import AprobationStatus from '@/models/porposal/aprobationStatus.model';
import ProposalDisbursement from '@/models/porposal/proposalDisbursement.model';
import ProposalCancelled from '../models/porposal/proposalCancelled.model';
export default class PorposalService {
  baseApiPublish = new BaseApi("Porposal");

  async getEvaluationsByProposalId(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetEvaluationsByProposalId/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async UpdateCreatedByProporsal() {
    var baseApi = new BaseApi(`Porposal/UpdateOldProposalCodes`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "PUT",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }


  getFondocytRequiredInformation(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetFondocytRequiredInformation/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getOptimizedProposal(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalOptimized/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getProposalHistoryById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalHistoryById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getProposalMembersById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalMembersById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getProposalGanttDiagramById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalGanttDiagramById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getProposalAnaliticalMatrixById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalAnaliticalMatrixById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getProposalResearchCenterById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalResearchCenterById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getProposalResearchCenterArticulatedById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalResearchCenterArticulatedById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getProposalDocumentsById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalDocumentsById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getProposalResearchLineAndFieldAreaById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalResearchLineAndFieldAreaById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getProposalCoinFacultyById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalCoinFacultyById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getProposalAreaById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalAreaById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }
  
  getProposalPorposalProjectTypesId(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalPorposalProjectTypesId/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getProposalDetailGeneralDescriptionFirstPartById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalDetailGeneralDescriptionFirstPartById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }
  
  getProposalBibliographyById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalBibliographyById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  //

  getProposalDetailGeneralDescriptionSecondPartById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalDetailGeneralDescriptionSecondPartById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getProposalDetailLiteraryRevisionById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalDetailLiteraryRevisionById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getProposalDetailMethodologyById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalDetailMethodologyById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getProposalDetailInstitutionalEnviromentById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalDetailInstitutionalEnviromentById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getProposalDisbursementId(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalDisbursementId/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getProposalBudgetItemsById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalBudgetItemsById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  //
  
  getProposalConsotiumsById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalConsotiumsById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getProposalArticulatedInvestigadorById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalArticulatedInvestigadorById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getProposalUsersReportsById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProposalUsersReportsById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getProporsalUsersEvaluatorsById(proposalId: number) {
    var baseApi = new BaseApi(`Porposal/GetProporsalUsersEvaluatorsById/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }
  
  //
  
  validaIsInvestigator(proposalId: number, userId: number) {
    var baseApi = new BaseApi(`Porposal/ValidaIsInvestigator/${proposalId}/ByUserId/${userId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async getUserReportsQuantityByProposald(proposalId: number) {
    var baseApi = new BaseApi(`PorposalUserReport/GetUserReportsCountByProposald/${proposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async downloadForm() {
    var baseApi = new BaseApi(`Porposal/DownloadForm`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async addHistoricPercentDone(model: any): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "PUT",
        "AddHistoricPercentDone",
        model,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async deleteHistoricPercentDone(model: any): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "PUT",
        "DeleteHistoricPercentDone",
        model,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async aprobarPropuestaCI(model: any): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "PUT",
        "AprobarPropuestaCI",
        model,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async updateProjectState(id: number) {
    var baseApi = new BaseApi("Porposal/UpdateProjectState/" + id);
    return new Promise<Porposal>((resolve, reject) =>
      baseApi.request(
        "PUT",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async requestLastReport(id: number) {
    var baseApi = new BaseApi("Porposal/RequestLastReport/" + id);
    return new Promise<Porposal>((resolve, reject) =>
      baseApi.request(
        "PUT",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async rechazarPropuesta(model: any): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "PUT",
        "RechazarPropuesta",
        model,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async deleteProposalById(id: number) {
    var baseApi = new BaseApi("Porposal/delete/proposal/" + id);
    return new Promise<Porposal>((resolve, reject) =>
      baseApi.request(
        "DELETE",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async validateIfExistProposalByName(name: string) {
    var baseApi = new BaseApi("Porposal/validateIfExist/proposal/" + name);
    return new Promise<Porposal>((resolve, reject) =>
      baseApi.request(
        "DELETE",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async agregarEvaluadoresALaPropuesta(model: any): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "POST",
        "AgregarEvaluadoresALaPropuesta",
        model,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async rechazarODevolverPropuesta(model: any): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "PUT",
        "RechazarODevolverPropuesta",
        model,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async devolverPropuesta(model: any): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "PUT",
        "DevolverPropuesta",
        model,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async managePropuestaFC(model: any): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "PUT",
        "ManagePropuestaFC",
        model,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async getAll(): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "GET",
        "GetAll",
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async getSended(): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "GET",
        "getSended",
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }
  async sendPorposal(
    sendedPorposal: SendedPorposal
  ): Promise<SendedPorposal> {
    return new Promise<SendedPorposal>((resolve, reject) =>
      this.baseApiPublish.request(
        "PUT",
        "Enviar/" + sendedPorposal.id,
        sendedPorposal,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async changeAprobationStatus(
    porposalId: Number,
    aprobationStatus: AprobationStatus
  ): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "PUT",
        "ChangeAprobationStatus/" + porposalId,
        aprobationStatus,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async addProposalUserReport(
    porposalId: Number,
    data: any
  ): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "PUT",
        "AddProposalUserReport/" + porposalId,
        data,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async updateProposalUserReport(
    porposalId: Number,
    data: any
  ): Promise<any> {
    let baseApi = new BaseApi("PorposalUserReport");
    return new Promise<any>((resolve, reject) =>
    baseApi.request(
        "PUT",
        `${porposalId}`,
        data,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async updateMatrizAnalitica(
    porposalId: Number,
    data: any
  ): Promise<any> {
    let baseApi = new BaseApi(`Porposal/ActualizarMatrizAnalitica/${porposalId}`);
    return new Promise<any>((resolve, reject) =>
    baseApi.request(
        "PUT",
        String(),
        data,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }


  async addBugetsToProposal(
    porposalId: Number,
    data: any
  ): Promise<any> {
    let baseApi = new BaseApi("Porposal/AddBugetsToProposal");
    return new Promise<any>((resolve, reject) =>
    baseApi.request(
        "PUT",
        `${porposalId}`,
        data,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async addClosingBugetToProposal(
    porposalId: Number,
    data: any
  ): Promise<any> {
    let baseApi = new BaseApi("Porposal/AddClosingBugetToProposal");
    return new Promise<any>((resolve, reject) =>
    baseApi.request(
        "PUT",
        `${porposalId}`,
        data,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async deleteProposalUserReport(
    id: Number
  ): Promise<any> {
    let baseApi = new BaseApi("PorposalUserReport");
    return new Promise<any>((resolve, reject) =>
    baseApi.request(
        "DELETE",
        `${id}`,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async executeProject(
    porposalId: Number,
    proposalDisbursement: ProposalDisbursement
  ): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "PUT",
        "ExecuteProject/" + porposalId,
        proposalDisbursement,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async updateDirsbursement(
    porposalId: any,
    proposalDisbursement: ProposalDisbursement
  ): Promise<any> {
    var baseApi = new BaseApi(`ProposalDisbursement`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "PUT",
        porposalId,
        proposalDisbursement,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async getDirsbursementByProposal(
    porposalId: any
  ): Promise<any> {
    var baseApi = new BaseApi(`ProposalDisbursement/GetByProposalId/${porposalId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async cancelledProject(
    porposalId: Number,
    proposalCancelled: ProposalCancelled
  ): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "PUT",
        "CancelledProject/" + porposalId,
        proposalCancelled,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async getPorposalUserReportEvaluationById(id: number) {
    var baseApi = new BaseApi(`PorposalUserReportEvaluation/${id}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async getPorposalUserReportById(id: number) {
    var baseApi = new BaseApi(`PorposalUserReport/${id}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async getPorposalLastReportEvaluationById(id: number) {
    var baseApi = new BaseApi(`PorposalUserReport/GetLastReportEvaluationById/${id}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }


  async updatePorposalUserReportEvaluation(
    id: Number,
    data: any
  ): Promise<any> {
    let baseApi = new BaseApi("PorposalUserReportEvaluation");
    return new Promise<any>((resolve, reject) =>
    baseApi.request(
        "PUT",
        `${id}`,
        data,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async addPorposalDisbursement(
    data: any
  ): Promise<any> {
    let baseApi = new BaseApi("ProposalDisbursement");
    return new Promise<any>((resolve, reject) =>
    baseApi.request(
        "POST",
        "",
        data,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

}
